export enum InteractionMode {
    CONTACTLESS,
    TOUCH,
    QR,
    TOUCH_QR
}
